// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"951d3d73","371":"b15b5cdd","919":"4da82546","1866":"e353d55c","2333":"951d3d73","2925":"afc21cde","3432":"951d3d73","3706":"951d3d73","5723":"e353d55c","6365":"951d3d73","8584":"951d3d73","9952":"951d3d73"}[chunkId] + ".chunk.css";
};